var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExhausted(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 105,
    viewBox: "0 0 158 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8864_2039)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.417 26.25H143.464C139.152 11.1169 125.162 0 108.625 0H36.2083C16.2477 0 0 16.1897 0 36.0938V68.9062C0 88.8103 16.2477 105 36.2083 105H108.625C125.169 105 139.152 93.8831 143.464 78.75H151.417C155.051 78.75 158 75.81 158 72.1875V32.8125C158 29.19 155.051 26.25 151.417 26.25ZM125.083 68.9062C125.083 77.9494 117.703 85.3125 108.625 85.3125H36.2083C27.1299 85.3125 19.75 77.9494 19.75 68.9062V36.0938C19.75 27.0506 27.1299 19.6875 36.2083 19.6875H108.625C117.703 19.6875 125.083 27.0506 125.083 36.0938V68.9062Z",
    fill: "#FFD230"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 26,
    width: 18,
    height: 54,
    rx: 9,
    fill: "#FFD230"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8864_2039"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 158,
    height: 105,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExhausted);
export default __webpack_public_path__ + "static/media/exhausted.bcd4919978e0dabe3a702db5fd8c4aff.svg";
export { ForwardRef as ReactComponent };